import React from 'react'
import { DiagnosticReportBundle } from '../../../../../types/FHIRTypes/Bundle'
import { DiagnosticReportTable } from '@teschglobal/tg-fhir-react-components'
import PaginationButtons from '../../../../PaginationButtons'
import Table from 'react-bootstrap/Table'
import { Link } from 'react-router-dom'
import Code from '../../../DataTypes/Code'
import CodeableConcept from '../../../DataTypes/CodeableConcept'
import PeriodOrDateTime from '../../../DataTypes/PeriodOrDateTime'
import FhirLoader from '../../../../FhirLoader'
import { isDiagnosticReportBundle } from '../../../../../typeGuards/fhirTypes'

type DiagnosticReportListProps = {
    diagnosticReportsData?: DiagnosticReportBundle;
    isFetching: boolean;
    handleChangePage: (page: number) => void
    totalPages: number;
    currentPage: number;
}

const DiagnosticReportList: React.FC<DiagnosticReportListProps> = ({ diagnosticReportsData, isFetching, handleChangePage, totalPages, currentPage }) => {

    if (!isDiagnosticReportBundle(diagnosticReportsData)) return null
    const patientDiagnosticReports = diagnosticReportsData?.entry?.map((entry) => entry.resource) || []

    if (isFetching) {
        return <FhirLoader message='Loading...' />
    }

    return (

        <>
            {
                diagnosticReportsData && diagnosticReportsData.total > 0 && (
                    <div className='my-3 fw-bold'>
                        <span role="status" aria-live="polite">{diagnosticReportsData?.total.toLocaleString()} record(s) found</span>
                        <PaginationButtons
                            totalPages={totalPages}
                            currentPage={currentPage}
                            handleChangePage={handleChangePage}
                        />
                    </div>
                )
            }

            <DiagnosticReportTable diagnosticReports={patientDiagnosticReports} />

            {
                diagnosticReportsData && diagnosticReportsData.total > 0 && (
                    <div className='my-3 fw-bold'>
                        <PaginationButtons
                            totalPages={totalPages}
                            currentPage={currentPage}
                            handleChangePage={handleChangePage}
                        />
                    </div>
                )
            }
        </>
    )
}

export default DiagnosticReportList